import _ from "lodash";
import React, { Component } from "react";
import classes from "./MediaModal.scss";
import ImageViewer from "UIComponents/ImageViewer";
import VideoViewer from "UIComponents/VideoViewer";
import UIModal from "UIComponents/UIModal";
import AudioViewer from "UIComponents/AudioViewer";
import AudioPlayer from "UIComponents/AudioPlayer";
import TheatreModeV2 from "UIComponents/TheatreModeV2";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import PropTypes from "prop-types";
import {
  hasAudioNote,
  addHttpsInUrl,
  canOpenOfficeFileInPdftron,
  getStringAutoLinks,
  getWorkbookModeForMediaModal,
  PDFTRON_VIEWER_MODE_TYPES,
  canViewPdfInPdftron,
  getFileExtensionFromMimeType,
  generateRandomId,
  getStyleStrippedText,
} from "Utils";
import {
  MS_FILE_VIEWER_SUPPORTED_MIMETYPE,
  GOOGLE_FILE_VIEWER_SUPPORTED_MIMETYPE,
  MAX_FILE_SIZE_VIEWER_LIMIT,
  MS_FILE_VIEWER_URL,
  GOOGLE_FILE_VIEWER_URL,
} from "Constants";
import { SNPv2_VISITOR_PORTAL_PERM_GROUP } from "Constants/permissionConstants";
import { downloadFromUrl, openLinkInNewTab } from "modules/Services";
import { connect } from "react-redux";
import Workbook from "AppComponents/Workbook";
import { PdfTronViewerV3 } from "AppComponents/PdfTronViewer";
import ACLStore from "lib/aclStore";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import AssessmentToolsModal from "Worksheet/components/StudentWorksheetSubmission/AssessmentToolsModal";
import ToddleDoc from "AppComponents/ToddleDoc";
import AITutorCodeEditorModality from "AppComponents/AIComponents/AITutorCodeEditorModality";

class MediaModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hideTheatreMode: false,
    };

    this.checkAndOpenInNewTab();
  }

  checkAndOpenInNewTab = () => {
    const {
      openLinkInNewTab,
      downloadFromUrl,
      attachments,
      toggleDownloadBeginOverlay,
      mode,
    } = this.props;
    const attachment = _.first(attachments);

    const type = _.get(attachment, "type", "");
    const mimeType = _.get(attachment, "mimeType", "");
    let url = _.get(attachment, "url", "");
    const signedUrl = _.get(attachment, "signedUrl", "");

    const size = _.get(attachment, "metadata.size", 0);

    if ((type == "FILE" || type == "LINK") && showNewTheatreMode() == false) {
      let showOpenInView = true;
      let shouldOpenInPDFTron = false;

      if (type == "LINK") {
        url = addHttpsInUrl(url);
      } else if (type == "FILE") {
        // for google & office docs, if feature flag is enabled, use google viewer
        if (
          _.includes(
            [
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              "application/vnd.google-apps.document",
            ],
            mimeType
          ) &&
          ACLStore.can("FeatureFlag:GoogleViewerSupport")
        ) {
          url = `${GOOGLE_FILE_VIEWER_URL}${encodeURIComponent(
            signedUrl || url
          )}`;
        } else if (mimeType == "application/pdf") {
          // check to open pdftron for pdf files
          shouldOpenInPDFTron = mode === "edit" ? true : canViewPdfInPdftron();
        } else if (
          _.includes(attachment.url, "blob:") ||
          !(
            _.includes(GOOGLE_FILE_VIEWER_SUPPORTED_MIMETYPE, mimeType) ||
            _.includes(MS_FILE_VIEWER_SUPPORTED_MIMETYPE, mimeType)
          ) ||
          size >= MAX_FILE_SIZE_VIEWER_LIMIT
        ) {
          showOpenInView = false;
        } else if (
          _.includes(GOOGLE_FILE_VIEWER_SUPPORTED_MIMETYPE, mimeType)
        ) {
          url = `${GOOGLE_FILE_VIEWER_URL}${encodeURIComponent(
            signedUrl || url
          )}`;
        } else if (_.includes(MS_FILE_VIEWER_SUPPORTED_MIMETYPE, mimeType)) {
          url = `${MS_FILE_VIEWER_URL}${encodeURIComponent(signedUrl || url)}`;
        }

        // check to open pdftron for msoffice files
        if (
          mimeType !== "application/pdf" &&
          (_.includes(GOOGLE_FILE_VIEWER_SUPPORTED_MIMETYPE, mimeType) ||
            _.includes(MS_FILE_VIEWER_SUPPORTED_MIMETYPE, mimeType))
        ) {
          shouldOpenInPDFTron = canOpenOfficeFileInPdftron();
        }
      }

      if (!shouldOpenInPDFTron) {
        if (showOpenInView) {
          openLinkInNewTab({ url });
        } else {
          downloadFromUrl({
            attachment,
            shouldAskForSave: true,
          });
          toggleDownloadBeginOverlay?.();
        }
        this.closeMediaViewer();
      }
    }

    /**--Snp visitors can not open workbook as they do not have feature flags.
     * So, for them open workbook in new tab using public url-- */
    const isVisitor = ACLStore.can(SNPv2_VISITOR_PORTAL_PERM_GROUP);

    if (isVisitor && type === "WORKBOOK") {
      const url = _.get(attachment, "metadata.publicUrl", "");
      if (url) {
        openLinkInNewTab({ url });
      }
      this.closeMediaViewer();
    }
  };

  closeMediaViewer = event => {
    const { toggleMediaModal } = this.props;
    if (event) {
      event.stopPropagation();
    }
    if (toggleMediaModal) {
      toggleMediaModal(false);
    }
  };

  getMediaRender = attachment => {
    if (!_.has(attachment, "type")) return null;

    let mediaToRender = null;
    const {
      mode,
      onWorkbookUpdateSuccessfully,
      userInfo,
      showPdfTronfeedback,
      showPdfTronEditButton,
      videoAutoPlayOnClick = false,
      showDownloadVideoButton = false,
    } = this.props;
    // const imageUrl = attachment.thumbUrl ? attachment.thumbUrl : attachment.url;
    let fileExtension = getFileExtensionFromMimeType({
      mimeType: _.get(attachment, "mimeType"),
    });
    fileExtension =
      fileExtension == false
        ? _.last(_.split(_.last(_.split(attachment?.url, "/")), ".")) // if lib. fails to detect file extension
        : fileExtension;

    switch (_.get(attachment, "type", "")) {
      case "IMAGE":
        mediaToRender = (
          <ImageViewer
            allowDrag={true}
            activeIndex={this.props.activeIndex}
            attachment={attachment}
            closeImageViewer={this.closeMediaViewer}
            attachmentsArray={_.filter(
              this.props.attachments,
              attachment => attachment.type == "IMAGE"
            )}
          />
        );
        break;
      case "VIDEO":
        mediaToRender = (
          <VideoViewer
            isHLSUrl={attachment.streamUrl ? true : false}
            videoUrl={
              attachment.streamUrl ? attachment.streamUrl : attachment.url
            }
            fileUrl={attachment?.url}
            closeVideoViewer={this.closeMediaViewer}
            autoPlay={videoAutoPlayOnClick}
            showDownloadButton={showDownloadVideoButton}
            fileExtension={fileExtension}
          />
        );
        break;
      case "AUDIO":
        mediaToRender = (
          <AudioViewer
            audioUrl={attachment?.url}
            closeViewer={this.closeMediaViewer}
          />
        );
        break;
      case "LINK":
        mediaToRender = null;
        break;
      case "FILE":
        mediaToRender = (
          <PdfTronViewerV3
            file={attachment}
            key={attachment.id}
            shouldShowGiveFeedbackButton={
              showPdfTronEditButton ? showPdfTronfeedback : false
            }
            closeViewer={this.closeMediaViewer}
            pdftronViewerMode={
              showPdfTronEditButton
                ? PDFTRON_VIEWER_MODE_TYPES["STUDENT_EDITOR"]
                : PDFTRON_VIEWER_MODE_TYPES["VIEWER"]
            }
            annotationUserInfo={userInfo}
          />
        );
        break;
      case "NOTE": {
        const noteHeight = 360 - 48;
        const numOfLines = Math.floor(noteHeight / 22);
        mediaToRender = (
          <div className={classes.imageContainer}>
            <div className={classes.topPanel}>
              <div className={classes.crossSvg} onClick={this.closeMediaViewer}>
                <CloseOutlined
                  size="xx-small"
                  variant="on"
                  className={classes.closeIcon}
                />
              </div>
            </div>
            <div className={classes.noteView}>
              {/* <div className={classes.noteViewWrapper}>{attachment.title}</div> */}
              <div className={classes.noteLinesContainer}>
                <div
                  className={classes.noteViewWrapper}
                  dangerouslySetInnerHTML={{
                    __html: getStyleStrippedText({
                      text: getStringAutoLinks(_.get(attachment, "title")),
                      type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                    }),
                  }}
                ></div>
              </div>
            </div>
          </div>
        );
        break;
      }
      default:
        break;
    }
    return mediaToRender;
  };

  onDiscardDirectly = () => {
    this.closeMediaViewer();
  };

  onAfterDiscardDirectly = () => {
    const { onWorkbookDiscardDirectly } = this.props;
    if (onWorkbookDiscardDirectly) {
      onWorkbookDiscardDirectly();
    }
  };

  setHideTheatreMode = value => {
    this.setState({ hideTheatreMode: value });
  };

  render() {
    const {
      showWorkBook,
      attachments,
      workbookMode,
      onWorkbookUpdateSuccessfully,
      onWorkSheetDiscard,
      mode,
      updateAttachments,
      editButtonLabel,
      assessmentTools = [],
      assessmentToolsEvaluationDetails = {},
      showPdfTronEditButton,
      showPdfTronfeedback,
      portalType,
      isWorksheet,
      curriculumProgramType,
      theatreModeV2OverlayContainer,
      allowedPermissions,
      setCurrentAttachmentIndex,
      canDownloadMedia,
      testId,
      assessmentId,
      assignmentId,
      showRevampedEvaluationUI = false,
      showAllTools = false,
      showEditResponseButtonProps = false,
      showMediaInModal,
      toddleDocMode,
      selectedAttachment,
      activeIndex,
      sourceType,
    } = this.props;
    const { hideTheatreMode } = this.state;
    const attachment = attachments ? attachments[0] : null;
    const renderMedia = this.getMediaRender(attachment);
    const isAudio = hasAudioNote({ attachments });
    const attachmentType = _.get(attachment, "type", "");
    const mimeType = _.get(attachment, "mimeType", "");
    const isEditableToddleDoc =
      _.get(selectedAttachment || attachments?.[activeIndex], "type", "") ===
        "TODDLE_DOC" &&
      (toddleDocMode === "EDIT" || hideTheatreMode);
    const isOpeningResourceInTutor = _.isEqual(
      sourceType,
      "OPENING_MESSAGE_RESOURCE"
    );
    const codeEditorAttachment = attachments?.[activeIndex];
    const isCodeEditorEditable =
      _.get(codeEditorAttachment, "type", "") === "CODE_EDITOR" &&
      hideTheatreMode;

    const ModeComponent = hideTheatreMode
      ? null
      : showMediaInModal
      ? AssessmentToolsModal
      : showNewTheatreMode()
      ? TheatreModeV2
      : null;

    const onEditAttachmentClick = isOpeningResourceInTutor
      ? () => {
          this.setHideTheatreMode(true);
        }
      : _.get(this.props, "onEditAttachmentClick");

    if (isEditableToddleDoc) {
      return (
        <ToddleDoc
          showFiltersForEditMode={true}
          onClose={this.onDiscardDirectly}
          attachment={selectedAttachment || attachments?.[activeIndex]}
        />
      );
    } else if (isCodeEditorEditable) {
      return (
        <AITutorCodeEditorModality
          attachmentId={
            codeEditorAttachment?.attachmentId || codeEditorAttachment?.id
          }
          onClose={this.onDiscardDirectly}
        />
      );
    } else if (ModeComponent) {
      return (
        <ModeComponent
          testId={testId}
          mediaAttachments={{ attachments: attachments }}
          activeAttachmentIndex={activeIndex}
          toggleTheatreMode={this.props.toggleMediaModal}
          iframeIdSelector={"workbook-iframe-" + generateRandomId()}
          onDiscardDirectly={this.closeMediaViewer}
          onWorkbookUpdateSuccessfully={onWorkbookUpdateSuccessfully}
          onAfterDiscardDirectly={this.onAfterDiscardDirectly}
          updateAttachments={updateAttachments}
          showWorkBook={showWorkBook}
          mode={mode}
          workbookMode={workbookMode}
          editButtonLabel={editButtonLabel}
          assessmentTools={assessmentTools}
          assessmentToolsEvaluationDetails={assessmentToolsEvaluationDetails}
          showPdfTronfeedback={
            showPdfTronEditButton ? showPdfTronfeedback : false
          }
          onWorkSheetDiscard={onWorkSheetDiscard}
          pdftronViewerMode={
            showPdfTronEditButton
              ? PDFTRON_VIEWER_MODE_TYPES["STUDENT_EDITOR"]
              : PDFTRON_VIEWER_MODE_TYPES["VIEWER"]
          }
          onEditAttachmentClick={onEditAttachmentClick}
          showEditResponseButton={_.get(
            this.props,
            "showEditResponseButton",
            false
          )}
          canOpenGoogleFilesInNewTab={_.get(
            this.props,
            "canOpenGoogleFilesInNewTab",
            true
          )}
          isWorksheet={isWorksheet}
          curriculumProgramType={curriculumProgramType}
          theatreModeV2OverlayContainer={theatreModeV2OverlayContainer}
          portalType={portalType}
          allowedPermissions={allowedPermissions}
          setCurrentAttachmentIndex={setCurrentAttachmentIndex}
          canDownloadMedia={canDownloadMedia}
          assessmentId={assessmentId}
          assignmentId={assignmentId}
          showRevampedEvaluationUI={showRevampedEvaluationUI}
          showAllTools={showAllTools}
          showEditResponseButtonOverride={showEditResponseButtonProps}
          showMediaInModal={showMediaInModal}
          showEditFrameOption={_.isEqual(sourceType, "STUDENT_TEMPLATE")}
        />
      );
    } else
      return (showWorkBook && attachmentType === "IMAGE") ||
        attachmentType === "WORKBOOK" ? (
        <Workbook
          attachment={attachment}
          workbookMode={getWorkbookModeForMediaModal({
            attachmentType,
            mode,
            workbookMode,
          })}
          onUpdateSuccessfully={onWorkbookUpdateSuccessfully}
          onDiscardDirectly={this.onDiscardDirectly}
          onAfterDiscardDirectly={this.onAfterDiscardDirectly}
          updateAttachments={updateAttachments}
          portalType={portalType}
        />
      ) : (
        <UIModal
          isOpen={true}
          isFullScreen={true}
          modalContent={classes.modalContent}
          overlayContainer={classes.overlayContainer}
          onRequestClose={this.closeMediaViewer}
        >
          {renderMedia}
          {isAudio &&
            !(
              _.isEqual("application/pdf", mimeType) && canViewPdfInPdftron()
            ) && (
              <div className={classes.audioAttachment}>
                <AudioPlayer
                  attachment={this.props.attachments[1]}
                  mediaType={"secondary"}
                ></AudioPlayer>
              </div>
            )}
        </UIModal>
      );
  }
}

MediaModal.propTypes = {
  toggleMediaModal: PropTypes.func,
  attachments: PropTypes.array,
  testId: PropTypes.string,
  showMediaInModal: PropTypes.bool,
};

MediaModal.defaultProps = {
  attachments: [],
  testId: "UIComponents",
  showMediaInModal: false,
};
const mapStateToProps = state => {
  const userInfo = _.pick(_.get(state, "login.userInfo", {}), [
    "id",
    "first_name",
    "last_name",
    "email",
    "userEntityType",
    "user_type",
  ]);

  return {
    userInfo,
  };
};

const mapActionCreators = {
  downloadFromUrl,
  openLinkInNewTab,
};

export default connect(mapStateToProps, mapActionCreators)(MediaModal);
